import React from 'react';

export function ChevronRight({ width = 16, height = 16, strokeColor = 'currentColor', strokeWidth = 2, ...props }) {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6 3 L11 8 L6 13"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
